// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2gwyZ","tagContent":"styles_tagContent__3mr_W"};